var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"appRoot"}},[_c('v-app',{staticClass:"app",attrs:{"id":"inspire"}},[_c('PageHeader'),_c('RouterView'),_c('PageFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }